import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {CbDialogModule} from '@app/shared/components/dialog/dialog.module';
import {FormsModule} from '@angular/forms';
import {CbFormsModule} from '@app/shared/components/forms/forms.module';
import {BuildMilestoneTemplatesComponent} from "@app/views/settings/pages/build-milestone-templates/build-milestone-templates.component";
import { BuildMilestoneTemplateDialogComponent } from './build-milestone-template-dialog/build-milestone-template-dialog.component';
import {CbInfoMessageModule, CbLoadingSpinnerModule} from "cb-hub-lib";

@NgModule({
    declarations: [
        BuildMilestoneTemplatesComponent,
        BuildMilestoneTemplateDialogComponent
    ],
    imports: [
        CommonModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        CbDialogModule,
        MatDialogModule,
        FormsModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatInputModule,
        MatTableModule,
        CbFormsModule,
        CbInfoMessageModule,
        CbLoadingSpinnerModule,
    ],
    exports: [
        BuildMilestoneTemplatesComponent
    ]
})
export class BuildMilestoneTemplateSettingsModule { }
